// extracted by mini-css-extract-plugin
export default {"signatureContainer":"SignatureModal_signatureContainer__UvAyz"};